// extracted by mini-css-extract-plugin
export var alertIcon = "_qp-0";